import {
  createSelector,
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';

import type { UploaderState } from '@iconik-io/uploader/src/state';

export type UploaderStatesState = Record<string, UploaderState>;

export type UploaderStatesAppState = { uploaderStates: UploaderStatesState };

const initialState: UploaderStatesState = {};

/**
 * The upload scheduler's own state storage. The scheduler writes it through
 * UploaderStateStorageRedux and the UI reads it; nothing else writes it.
 */
export const uploaderStatesSlice = createSlice({
  name: 'uploaderStates',
  initialState,
  reducers: {
    uploaderStateSet: (
      state,
      action: PayloadAction<{ stateId: string; state: UploaderState }>,
    ) => {
      state[action.payload.stateId] = action.payload.state;
    },
    uploaderStateDeleted: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
    },
  },
});

export const { uploaderStateSet, uploaderStateDeleted } =
  uploaderStatesSlice.actions;

export const uploaderStatesReducer = uploaderStatesSlice.reducer;

export const selectUploaderStates = (
  state: UploaderStatesAppState,
): UploaderStatesState => state.uploaderStates;

export const selectUploaderState = (
  state: UploaderStatesAppState,
  stateId: string,
): UploaderState | undefined => state.uploaderStates[stateId];

/** Uploads in the order they were queued. */
export const selectUploaderStateList = createSelector(
  [selectUploaderStates],
  (states) => Object.values(states),
);
